module.exports = __webpack_public_path__ + "img/company-4.b0c3969e.jpg";